import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { FaImage } from 'react-icons/fa';

const ROFolderDemoImg = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [imageData, setImageData] = useState(null);
    const location = useLocation();


    useEffect(() => {
        // Extract image URL from query parameters
        const urlParams = new URLSearchParams(location.search);
        const imageUrl = urlParams.get('url');
        const fileName = urlParams.get('name') || 'Image';
        const mimeType = urlParams.get('mimeType') || 'image/jpeg';

        if (!imageUrl) {
            setError("No image URL provided");
            setLoading(false);
            return;
        }

        // Set image data
        setImageData({
            url: imageUrl,
            name: fileName,
            mimeType: mimeType
        });
        setLoading(false);
    }, [location.search]);



    if (loading) {
        return (
            <Container className="mt-4">
                <Row className="justify-content-center">
                    <Col md={8} className="text-center">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        <p className="mt-2">Loading image...</p>
                    </Col>
                </Row>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-4">
                <Row className="justify-content-center">
                    <Col md={8}>
                        <Alert variant="danger">
                            <h4>Error</h4>
                            <p>{error}</p>
                        </Alert>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <Row>
                <Col>
                    <Card>
                        <Card.Header>
                            <h4 className="mb-0">
                                <FaImage className="me-2" />
                                {imageData.name}
                            </h4>
                        </Card.Header>
                        <Card.Body className="text-center">
                            <div className="mb-3">
                                <img
                                    src={imageData.url}
                                    alt={imageData.name}
                                    className="img-fluid"
                                    style={{ 
                                        maxWidth: '100%', 
                                        maxHeight: '70vh',
                                        objectFit: 'contain'
                                    }}
                                    onError={(e) => {
                                        setError("Failed to load image. The image may not be accessible from this domain.");
                                    }}
                                />
                            </div>
                            <div className="text-muted small">
                                <p><strong>File:</strong> {imageData.name}</p>
                                <p><strong>Type:</strong> {imageData.mimeType}</p>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ROFolderDemoImg;
